// ============================================================================
// HOOK: useCloudSync — Gerenciamento de estado de sincronização com nuvem
// ARQUIVO: src/hooks/useCloudSync.js
// ============================================================================

import { useState, useEffect, useRef, useCallback } from "react";

const STATES = {
  IDLE: "idle",
  SAVING: "saving",
  SAVED: "saved",
  ERROR: "error",
};

export function useCloudSync() {
  const [cloudSyncState, setCloudSyncState] = useState(STATES.IDLE);
  const [cloudSyncMeta, setCloudSyncMeta] = useState({
    updatedAt: null,
    updatedBy: null,
    source: null,
    error: null,
  });

  const isCloudAutosaveInFlightRef = useRef(false);
  const lastCloudAutosavePayloadRef = useRef(null);

  const markSaving = useCallback(() => {
    setCloudSyncState(STATES.SAVING);
    setCloudSyncMeta((prev) => ({ ...(prev || {}), error: null }));
  }, []);

  const markSaved = useCallback((meta = {}) => {
    setCloudSyncState(STATES.SAVED);
    setCloudSyncMeta({
      updatedAt: new Date().toISOString(),
      updatedBy: null,
      source: null,
      error: null,
      ...meta,
    });
  }, []);

  const markError = useCallback((error, source = "cloud") => {
    setCloudSyncState(STATES.ERROR);
    setCloudSyncMeta((prev) => ({
      ...(prev || {}),
      error: error?.message || String(error),
      source,
    }));
  }, []);

  const reset = useCallback(() => {
    setCloudSyncState(STATES.IDLE);
    setCloudSyncMeta({
      updatedAt: null,
      updatedBy: null,
      source: null,
      error: null,
    });
    lastCloudAutosavePayloadRef.current = null;
    isCloudAutosaveInFlightRef.current = false;
  }, []);

  return {
    cloudSyncState,
    setCloudSyncState,
    cloudSyncMeta,
    setCloudSyncMeta,
    isCloudAutosaveInFlightRef,
    lastCloudAutosavePayloadRef,
    markSaving,
    markSaved,
    markError,
    reset,
  };
}

export default useCloudSync;
